import {
  createContext,
  useContext,
  useState,
  type ReactNode,
  useEffect,
} from "react";

export interface LoadingContextType {
  // State
  isLoading: boolean;
  setLoading: (value: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export function LoadingContextProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const value: LoadingContextType = {
    isLoading,
    setLoading: setIsLoading,
  };

  useEffect(() => {
    if (isLoading) {
      window.scrollTo(0, 0);
    }
  }, [isLoading]);

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
}

export function useLoadingOverlay() {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error(
      "useLoadingOverlay must be used within a LoadingContextProvider",
    );
  }
  return context;
}
